export function BeautifulCircleIcon() {
    return (
        <svg
                className='beautifulCircleIcon'
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                fill="none"
                viewBox="0 0 13 13"
                >
                <circle
                    cx="6.5"
                    cy="6.5"
                    r="6.5"
                    fill="url(#paint0_linear_35_1449)"
                ></circle>
                <defs>
                    <linearGradient
                    id="paint0_linear_35_1449"
                    x1="11.315"
                    x2="6.5"
                    y1="5.056"
                    y2="13"
                    gradientUnits="userSpaceOnUse"
                    >
                    <stop stopColor="#0767F4"></stop>
                    <stop offset="1" stopColor="#30D1E0"></stop>
                    </linearGradient>
                </defs>
                </svg>
    )
}